import { createContext, useEffect, useState } from 'react';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [isLoadingContext, setIsLoadingContext] = useState(false);
  const [user, setUser] = useState(null);
  const [auth, setAuth] = useState(false);
  const [otraCabana, setOtraCabana] = useState(() => {
    const cabanaStorage = JSON.parse(localStorage.getItem('cabana'));
    return cabanaStorage || false;
  });

  useEffect(() => {
    const userStorage = JSON.parse(localStorage.getItem('user'));
    if (!userStorage) {
      localStorage.removeItem('user');
    } else {
      setUser(userStorage);
    }
  }, []);

  useEffect(() => {
    if (user) {
      localStorage.setItem('user', JSON.stringify(user));
    } else {
      localStorage.removeItem('user');
    }
  }, [user]);

  useEffect(() => {
    localStorage.setItem('cabana', JSON.stringify(otraCabana));
  }, [otraCabana]);

  const data = {
    user,
    setUser,
    auth,
    setAuth,
    otraCabana,
    setOtraCabana,
    isLoadingContext,
    setIsLoadingContext,
  };

  return <UserContext.Provider value={data}>{children}</UserContext.Provider>;
};

export default UserContext;
